import useIntl from '@/infrastructure/hooks/useIntl';
import getHtmlFromMarkdown from '@/utils/markdown/getHtmlFromMarkdown';
import { useAtom } from 'jotai';

import useSendChatMessage from './api/useSendChatMessage';
import { parseChatReply } from './parseChatReply';
import { IMessage, MessageStatus, chatMessagesAtom } from './state';
import useHandleChatRequest from './useHandleChatRequest';

const useChat = () => {
  const t = useIntl('chat');
  const [chatMessages, setChatMessages] = useAtom(chatMessagesAtom);
  const { handleChatRequest } = useHandleChatRequest();
  const { sendChatMessage } = useSendChatMessage();

  const sendMessage = async (message: string) => {
    var queryMessage = {
      id: `${Date.now()}-C`,
      message,
      status: MessageStatus.Sent,
      isUserMessage: true
    };
    const responseMessage: IMessage = {
      id: `${Date.now()}-S`,
      isUserMessage: false,
      message: '',
      status: MessageStatus.Calculating
    };

    setChatMessages(chatMessages => ({
      chatId: chatMessages.chatId,
      messages: chatMessages.messages.concat([queryMessage, responseMessage])
    }));

    const sendToAgentAtTime = Date.now();
    const response = await sendChatMessage(
      queryMessage.message,
      chatMessages.chatId
    );

    if (response?.reply) {
      const [reply, json] = parseChatReply(response);

      responseMessage.message = getHtmlFromMarkdown(reply);

      if (json) {
        handleChatRequest(json, { source: 'agent', sendToAgentAtTime });
      }

      responseMessage.status = MessageStatus.Received;
      setChatMessages(chatMessages => {
        return {
          chatId: chatMessages.chatId,
          messages: chatMessages.messages
            .filter(m => m.id != responseMessage.id)
            .concat([responseMessage])
        };
      });
    }
  };

  const addLocalMessage = (message: string, type?: 'no-results-suggestions') => {
    setChatMessages(chatMessages => {
      return {
        chatId: chatMessages.chatId,
        messages: chatMessages.messages.concat([
          {
            id: `${Date.now()}-L`,
            isUserMessage: false,
            message: type ? '' : getHtmlFromMarkdown(message),
            status: MessageStatus.Received,
            type
          }
        ])
      };
    });
  };

  return {
    messages: chatMessages.messages,
    sendMessage,
    addLocalMessage
  };
};

export default useChat;
